'use strict';

export { default } from './dynamicPosViewHeader.container';